"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Navbar_1 = __importDefault(require("../components/Navbar"));
var ProfileBgroup_1 = __importDefault(require("../components/ProfileBgroup"));
var profilecomponetn_1 = __importDefault(require("./Profile/profilecomponetn"));
var material_1 = require("@mui/material");
function Profile() {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Navbar_1.default, { iconNumber: 5 }),
        react_1.default.createElement(material_1.Box, { sx: { display: "flex", flexDirection: "row" } },
            react_1.default.createElement(profilecomponetn_1.default, null),
            react_1.default.createElement(ProfileBgroup_1.default, null))));
}
exports.default = Profile;
